<template lang="pug">
i.flag-icon(:class="type", :style="`--flag: url(${flagUrl})`")
</template>

<script setup>
import { computed } from 'vue'

const { getFrontCdnUrl } = useCdnAssets()

const props = defineProps({
  country: String,
  type: {
    type: String,
    default: 'rectangular', // 'rectangular' 'square'
  },
})

const flagUrl = computed(() => {
  const aspectRatio = props.type === 'square' ? '1x1' : '4x3'
  return getFrontCdnUrl(`flags/${aspectRatio}/${props.country}.svg`)
})
</script>

<style scoped lang="scss">
.flag-icon {
  background-image: var(--flag);
  display: inline-block;
  line-height: 1em;
  position: relative;

  background-position: 50%;
  background-repeat: no-repeat;
  background-size: contain;
  width: 1.333333em;

  &.square {
    width: 1em;
  }

  &::before {
    content: ' ';
    white-space: pre;
  }
}
</style>
